module.exports = __webpack_public_path__ + "img/JO.c8cfe14d.svg";